import React from "react";
import { ReactComponent as ClipboardIcon } from "../../../assets/icons/clipboard.svg";
import { Box } from "../Box";
import { palette } from "../../../styles/theme";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { SxProps } from "@mui/material";

export interface CopyButtonProps {
  value: string;
  size?: "small" | "medium";
  sx?: SxProps;
}

const CopyButton = ({ value, size = "small", sx }: CopyButtonProps) => {
  const { t } = useTranslation();

  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    toast.success(t("general.copied_to_clipboard"));
  };
  return (
    <Box
      id="copy-button"
      sx={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "4px",
        width: size === "small" ? "16px" : "20px",
        height: size === "small" ? "16px" : "20px",
        "& svg": {
          width: size === "small" ? "12px" : "16px",
          height: size === "small" ? "12px" : "16px",
        },
        "&:hover": {
          backgroundColor: palette.grey.lightGrey,
          "& svg path": {
            stroke: palette.grey.nearBlack,
          },
        },
        ...sx,
      }}
      onClick={handleCopy}
    >
      <ClipboardIcon />
    </Box>
  );
};

export default CopyButton;
